import { createTheme } from "@mui/material/styles";
import { INewsletterSettings } from "../context/NewsletterSettingsContext";

export function Theme(settings: INewsletterSettings) {
    const components: any = {
        MuiScopedCssBaseline: {
            styleOverrides: {
                root: {
                    backgroundColor: "transparent"
                }
            }
        }
    };

    if (!settings.background) {
        components.MuiCard = {
            styleOverrides: {
                root: {
                    background: "transparent",
                    border: "none",
                    boxShadow: "none"
                }
            }
        };
    }

    let theme = createTheme({
        shape: {
            borderRadius: 5,
        },
        components,
    });
    
    return theme;
}

const loadTheme = (settings: INewsletterSettings) => import("./theme").then(({ Theme }) => Theme(settings));